import { render, staticRenderFns } from "./RegulationText.vue?vue&type=template&id=6eb86c74"
import script from "./RegulationText.vue?vue&type=script&lang=js"
export * from "./RegulationText.vue?vue&type=script&lang=js"
import style0 from "./RegulationText.vue?vue&type=style&index=0&id=6eb86c74&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports